import type { CSSProperties } from "react"

/**
 * Las tres voces tipográficas del manual de identidad, en milímetros. Todos los
 * formatos hablan con ellas, para que un rótulo se lea igual que el de al lado.
 */

/** Plus Jakarta Sans ExtraBold: títulos y códigos. */
export function titular(tamano: number, extra?: CSSProperties): CSSProperties {
  return {
    margin: 0,
    fontFamily: "var(--font-rotulo)",
    fontSize: `${tamano}mm`,
    fontWeight: 800,
    lineHeight: 1.05,
    color: "var(--impreso-noche)",
    ...extra,
  }
}

/** Versales espaciadas: el departamento y los nombres de campo. */
export function versal(tamano: number, extra?: CSSProperties): CSSProperties {
  return {
    margin: 0,
    fontFamily: "var(--font-rotulo)",
    fontSize: `${tamano}mm`,
    fontWeight: 700,
    letterSpacing: "0.24em",
    lineHeight: 1.2,
    textTransform: "uppercase",
    color: "var(--impreso-vino)",
    ...extra,
  }
}

/** Inter Medium: contenido, períodos y datos. */
export function dato(tamano: number, extra?: CSSProperties): CSSProperties {
  return {
    margin: 0,
    fontFamily: "var(--font-rotulo-texto)",
    fontSize: `${tamano}mm`,
    fontWeight: 500,
    lineHeight: 1.3,
    color: "var(--impreso-noche)",
    ...extra,
  }
}

/** El filete de oro: nunca texto, sólo esta línea. */
export function filete(extra?: CSSProperties): CSSProperties {
  return { height: "0.26mm", flexShrink: 0, background: "var(--impreso-oro-2)", ...extra }
}

/**
 * El cuerpo con el que un texto cabe en una línea de `util` mm. El 0,62 es el ancho medio
 * de un carácter de esta letra; `piso` evita que un texto largo acabe sin leerse.
 */
export function cuerpoEnLinea(texto: string, util: number, tope: number, piso = 2.2): number {
  const cifra = Math.max(texto.length, 1) * 0.62
  return Math.max(piso, Math.min(tope, util / cifra))
}
